__turbopack_context__.v({
  "anchor": "uploadMethodMenu-module-scss-module__T6ytMG__anchor",
  "menu": "uploadMethodMenu-module-scss-module__T6ytMG__menu",
  "menuIcon": "uploadMethodMenu-module-scss-module__T6ytMG__menuIcon",
  "menuItem": "uploadMethodMenu-module-scss-module__T6ytMG__menuItem",
  "menuUp": "uploadMethodMenu-module-scss-module__T6ytMG__menuUp",
});
